module.exports = __webpack_public_path__ + "static/adpoke-8707e57cfdae1ff1dffaeee869827a0a.jpg";